import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import {
  useAccount,
  useContractRead,
  useContractWrite,
  useNetwork,
  useWaitForTransaction,
} from 'wagmi';
import * as Yup from 'yup';
import { SUCCESSMSGS, TRANSACTIONMSGS } from '../../utils/messages';
import { ethers } from 'ethers';
import { toast } from 'react-toastify';
import { PRESALE_MANAGER_LIMIT_ADDRESSESS, SALE_TYPE, USDT_ADDRESSESS } from '../../_constant';
import PreSaleManagerWithLimit from '../../_constant/PreSaleManagerWithLimit.json';
import PreSaleManagerEth from '../../_constant/PreSaleManagerEth.json';
import SimpleToken from '../../_constant/SimpleToken.json';
import { fetchBalance } from '@wagmi/core';
import { SyncLoader } from 'react-spinners';
import PreSale from '../../_constant/PreSale.json';
import PreSaleManager_V4 from '../../_constant/PreSaleManager_v4.json';
import FairLaunch from '../../_constant/FairLaunch.json';
import { delay, formatToken } from '../../utils';
import { getAccount } from '@wagmi/core';
import {
  PostErrorLogAction,
  postInvestAction,
  saveBlockTransactionsAction,
} from '../../redux/apiActions/api.action';
import { blockInvalidChar } from '../../_constant';
import config from '../../config';

export function BuyPresale({
  presaleDetails,
  getInvestDetailsFunc,
  referchFundraise,
  refetchInFBC,
  isContribute
}) {
  const [isDepositing, setIsDepositing] = useState(false);
  const { chain, chains } = useNetwork();
  const [percentage, setPercentage] = useState({});
  const [isLoadingOtp, setIsLoading] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [message, setMessage] = useState("");
  const [isOtpRecived, setIsOtpRecived] = useState(false);
  const [otp, setOtp] = useState('');
  const [couponBalance, setCouponBalance] = useState("");
  const [couponAmountAbleToDetect, setcouponAmountAbleToDetect] = useState();
  const [AbleToDetect, setAbleToDetect] = useState();
  const [amountDollar, setamountDollar] = useState();
  const [deductAmountID, setDeductAmountId] = useState('');



  const PRESALE_MANAGER_ADDRESS =
    PRESALE_MANAGER_LIMIT_ADDRESSESS[chain?.network];

  const PRESALE_USDT_ADDRESSESS =
    USDT_ADDRESSESS[chain?.network];

  console.log("couponAmountAbleToDetect", couponAmountAbleToDetect)
  const { isDisconnected, isConnected, address } = useAccount();

  const account = getAccount();

  let [balance, _balance] = useState();

  const closeModal = () => {
    // Find the close button or trigger element
    setCoupon('')
    setamountDollar('')
    setAbleToDetect('')
    const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.click(); // Programmatically trigger the click event to close the modal
    }
  };



  const getBalane = async () => {
    try {
      if (account?.address && isConnected) {
        const balance = await fetchBalance({
          address: address || undefined,
        });
        _balance(balance);
      }
    } catch (err) {
      _balance(0);
    }
  };

  useEffect(() => {
    getBalane();
  }, [address, chain]);
  const [dynamicAmountPass, setdynamicAmount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);


  // Fetch coupon percentage from the contract
  const {
    data: couponPercentage,
    isError: couponPercentageError,
    isLoading: couponPercentageLoading,
  } = useContractRead({
    address: PRESALE_MANAGER_ADDRESS,
    abi: PreSaleManager_V4.abi,
    functionName: 'couponPercentage',
  });


  // Handling loading and errors
  if (couponPercentageLoading) {
    console.log('Loading coupon percentage...');
  }

  if (couponPercentageError) {

    console.error('Error fetching coupon percentage: ...', couponPercentageError);
  }


  useEffect(() => {
    if (couponPercentage !== undefined) {
      setPercentage(couponPercentage?.toString()); // Update the state only when couponPercentage is available
    }
  }, [couponPercentage]);
  console.log('Coupon Percentage:...', couponPercentage?.toString());


  const {
    data: couponData,
    isError: couponUserError,
    isLoading: couponUserPercentageLoading,
  } = useContractRead({
    address: PRESALE_MANAGER_ADDRESS,
    abi: PreSaleManager_V4.abi,
    functionName: 'couponUserOf',
    args: [address, coupon],
  });

  // Handling loading and errors

  const [couponUserData, setCouponUserData] = useState(null);


  const sdasdcasd = couponUserData?.[0]
    ? ethers.utils.formatUnits(String(couponUserData[0]), 18)
    : null;

  console.log(sdasdcasd, "couponUserData", couponUserData?.[0]?.toString());

  useEffect(() => {
    if (coupon) {
      if (couponData !== undefined) {
        setCouponUserData(couponData); // Set couponUserData to state when available
        setIsLoading(false)
      }
      if (couponUserPercentageLoading) {
        console.log('coupon User Percentage Loading percentage...');
        setIsLoading(true)
      }

      if (couponUserError) {
        console.error('Error fetching coupon User Percentage: ...', couponUserError);
        setIsLoading(false)
      }
    }

  }, [couponData, coupon]);

  let dynamicDecimal;
  let isUSDT = false;
  let minBuy;
  let maxBuy;
  let amountValidateSchema;


  // console.log("presaleDetails?.fund_releasing_token", presaleDetails?.fund_releasing_token)

  // console.log("presaleDetails +++++++++++", presaleDetails)
  // console.log("buyToken +++++++++++", presaleDetails?.buyToken)
  // console.log("PRESALE_USDT_ADDRESSESS +++++++++++", PRESALE_USDT_ADDRESSESS)
  // console.log("presaleDetails +++++++++++", presaleDetails?.buyToken == PRESALE_USDT_ADDRESSESS)
  if (
    presaleDetails?.minBuy &&
    presaleDetails?.maxBuy &&
    presaleDetails?.fund_releasing_token
  ) {
    dynamicDecimal =
      presaleDetails?.fund_releasing_token === 'BNB' ||
        presaleDetails?.fund_releasing_token === 'MATIC'
        ? 18
        : presaleDetails?.custom_fund_token_decimal;
    isUSDT = presaleDetails?.buyToken?.toLowerCase().trim() === PRESALE_USDT_ADDRESSESS?.toLowerCase().trim();;
    minBuy = ethers.utils
      .formatUnits(String(presaleDetails?.minBuy), dynamicDecimal)
      ?.toString();
    maxBuy = ethers.utils
      .formatUnits(String(presaleDetails?.maxBuy), dynamicDecimal)
      ?.toString();

    amountValidateSchema = Yup.object().shape({
      amount: Yup.number()
        .min(minBuy, `Amount should be greater than or equal to ${minBuy}`)
        .max(maxBuy, `Amount should be less than or equal to ${maxBuy}`),
      // .required('Amount is required'),
    });
  }

  // console.log("isUSDT", isUSDT)
  const formik = useFormik({
    initialValues: {
      amount: '',
    },
    validationSchema: amountValidateSchema,
    onSubmit: async (data) => {
      try {
        setIsSubmitting(true);

        const buyTokenResponse = await fetchBalance({
          address: address,
          token: data.buyToken,
        });

        const tokenBalance = buyTokenResponse.data?.value || 0n;

        let dynamicAmount =
          presaleDetails?.buyWithETH == 'true'
            ? ethers.utils.parseUnits(String(data.amount), 18)?.toString()
            : ethers.utils
              .parseUnits(
                String(data.amount),
                Number(presaleDetails?.custom_fund_token_decimal)
              )
              ?.toString();

        if (dynamicAmount != undefined) {

          if (presaleDetails.buyToken === config.HLPR_ADDRESS) {
            if (investorLimit.allowed === 0n) {
              formik.setFieldError(
                'amount',
                `You are unable to buy as your buy limit is 0.`
              );
              return;
            } else if (BigInt(dynamicAmount) > investorLimit) {
              formik.setFieldError(
                'amount',
                `Amount should be less than or equal to buy limit (${Number(
                  data.amount
                ).toFixed(1)} <= ${ethers.utils.formatUnits(
                  investorLimit.allowed,
                  18
                )}).`
              );
              return;
            }
          }
          setdynamicAmount(dynamicAmount);
          if (presaleDetails?.buyWithETH == 'true') {
            investIntoPreSaleEth();
          } else {
            investIntoPreSaleNotEth();
          }
        }
      } catch (error) {
        console.log('Error', error);
        setIsSubmitting(false);
      }
    },
  });
  const balanceofCoupam = couponUserData?.[1]
    ? Number(ethers.utils.formatUnits(String(couponUserData[1]), 18))
    : 0;

  const adjustedAmount = formik.values.amount ? Number(formik.values.amount) - Math.min(balanceofCoupam, Number(couponAmountAbleToDetect || 0)) : 0;
  useEffect(() => {
    if (adjustedAmount > 0) {
      setamountDollar(adjustedAmount)
    }
  }, [adjustedAmount])

  const onApproveError = (error) => {
    PostErrorLogAction({
      address: account?.address || 0,
      other_detail: { error },
    });
    console.log('1 Error', error);

    let errStr = error.toString().slice(0, 25);
    if (errStr === 'TransactionExecutionError') {
      toast.error(TRANSACTIONMSGS.METAMASKREQUESTREJECT);
    } else if (
      error.toString().slice(0, 46) ===
      'ContractFunctionExecutionError: The total cost'
    ) {
      toast.error(TRANSACTIONMSGS.INSUFFICIENT_FUND);
    } else if (error.toString().includes('MaxBuyLimitExceeded')) {
      toast.error(TRANSACTIONMSGS.MAXBUYLIMITEXCEED);
    } else if (error.toString().includes('HardCapLimitExceeded')) {
      toast.error(TRANSACTIONMSGS.HARDCAPLIMITEXCEED);
    } else if (
      error.toString().includes('ERC20: transfer amount exceeds balance')
    ) {
      toast.error(
        `Insufficient ${presaleDetails?.custom_fund_raising_token_symbol}`
      );
    } else if (error.toString().includes('OnlyForLimitHolders')) {
      toast.error(`Only for limit holders.`);
    } else if (error.toString().includes('LimitExceed')) {
      toast.error(`Buy limit exceed.`);
    } else {
      toast.error(TRANSACTIONMSGS.SOMETHINGWENTWRONG);
    }
    setIsSubmitting(false);
  };
  const isUsingCoupon = coupon ? true : false;

  const investDataNotEthArgs = [

    presaleDetails?.preSale,
    presaleDetails?.custom_fund_token_decimal != undefined &&
      presaleDetails?.buyWithETH &&
      formik?.values.amount
      ? presaleDetails?.buyWithETH == 'true'
        // ? ethers.utils.parseUnits(String(adjustedAmount), 18).toString()
        ? ethers.utils.parseUnits(String(formik?.values?.amount), 18).toString()
        : ethers.utils
          .parseUnits(
            // String(adjustedAmount),
            String(formik?.values.amount),
            Number(presaleDetails?.custom_fund_token_decimal)
          )
          .toString()
      : '',
    coupon,
    isUsingCoupon

  ];

  const onclosekdas = () => {
    const modal = document.getElementById('exampleModal');
    modal.on('hidden.bs.modal', function (e) {
      alert("asASIuag")
    })
  }

  const {
    data: investDataNotEth,
    isLoading: isInvestNotEthLoading,
    write: investIntoPreSaleNotEth,
  } = useContractWrite({
    address: PRESALE_MANAGER_ADDRESS,
    abi: PreSaleManagerWithLimit.abi,
    functionName: 'investIntoPreSale',
    args: investDataNotEthArgs,
    // args: [presaleDetails?.preSale, (presaleDetails?.custom_fund_token_decimal != undefined && presaleDetails?.buyWithETH && formik?.values.amount) ? presaleDetails?.buyWithETH == "true" ? ethers.utils.parseUnits(String(formik?.values?.amount), 18).toString() : ethers.utils.parseUnits(String(formik?.values.amount), Number(presaleDetails?.custom_fund_token_decimal)).toString() : '',],
    // value:
    onError: onApproveError,
    onSuccess: async ({ hash }) => {
      try {
        await saveBlockTransactionsAction({
          action: 'investIntoPreSale',
          network_type: chain?.id,
          hash: hash,
          other_detail: {},
          address_out: address,
          args: investDataNotEthArgs,
        });
        // setCoupon("");
        // setCouponUserData(null);
        // setcouponAmountAbleToDetect();
        formik.resetForm(); // Reset the form values if applicable

      } catch (error) {
        console.log(error, 'Error saving block transaction');
        PostErrorLogAction({
          address: account?.address || 0,
          other_detail: { error },
        });
      }
    },
  });

  const investDataEthArgs = [presaleDetails?.preSale];

  const {
    data: investDataEth,
    isLoading: isInvestLoading,
    write: investIntoPreSaleEth,
  } = useContractWrite({
    address: PRESALE_MANAGER_ADDRESS,
    abi: PreSaleManagerEth.abi,
    functionName: 'investIntoPreSale',
    args: investDataEthArgs,
    // args: [presaleDetails?.preSale],
    value:
      presaleDetails?.custom_fund_token_decimal != undefined &&
        presaleDetails?.buyWithETH &&
        formik?.values.amount
        ? presaleDetails?.buyWithETH == 'true'
          ? ethers.utils
            .parseUnits(String(adjustedAmount), 18)
            // .parseUnits(String(formik?.values?.amount), 18)
            .toString()
          : ethers.utils
            .parseUnits(
              String(adjustedAmount),
              // String(formik?.values.amount),
              Number(presaleDetails?.custom_fund_token_decimal)
            )
            .toString()
        : '',
    onError: onApproveError,
    onSuccess: async ({ hash }) => {
      try {
        await saveBlockTransactionsAction({
          hash: hash,
          action: 'investIntoPreSale',
          address_out: address,
          args: investDataEthArgs,
          network_type: chain?.id,
          other_detail: {},
        });
      } catch (error) {
        console.log(error, 'Error saving block transaction');
        PostErrorLogAction({
          address: account?.address || 0,
          other_detail: { error },
        });
      }
    },
  });

  const {
    isError,
    isLoading,
    refetch: refetchInvestorContribution,
  } = useContractRead({
    address: config.SUPPORTED_NETWORKS.some(
      (network) => network.id === chain?.id
    )
      ? presaleDetails?.preSale
      : undefined,
    abi: SALE_TYPE.isPresaleOrPrivateSale(presaleDetails?.saleType)
      ? PreSale.abi
      : FairLaunch.abi,
    functionName: 'investorContribution',
    args: [address],
  });

  const {
    data: investorLimit,
    isLoading: isLoadingInvestorLimit,
    refetch: refetchInvestorLimit,
  } = useContractRead({
    address: PRESALE_MANAGER_ADDRESS,
    abi: PreSaleManagerWithLimit.abi,
    functionName: 'investorAllLimits',
    args: [address],
  });
  // console.log(investorLimit, 'investorLimits')

  const {
    isError: ReceiveTokensisError,
    isLoading: ReceiveTokensisLoading,
    refetch: refetchInvestorReceivedTokens,
  } = useContractRead({
    address: config.SUPPORTED_NETWORKS.some(
      (network) => network.id === chain?.id
    )
      ? presaleDetails?.preSale
      : undefined,
    abi: SALE_TYPE.isPresaleOrPrivateSale(presaleDetails?.saleType)
      ? PreSale.abi
      : FairLaunch.abi,
    functionName: 'investorReceivedTokens',
    args: [address],
  });
  console.log(coupon, "<<<<coupon");
  console.log(AbleToDetect, "<<<<AbleToDetect");
  console.log(amountDollar, "<<<<<<AbleToDetect");
  const onSuccessWaitForTransaction = async (receipt) => {
    setIsDepositing(true);
    refetchAllowance();
    refetchInvestorLimit();
    refetchInFBC();
    try {
      if (SALE_TYPE.isPresaleOrPrivateSale(presaleDetails?.saleType)) {
        const { data: dataContri } = await refetchInvestorContribution();
        const { data: dataReceiv } = await refetchInvestorReceivedTokens();

        // if (dataContri && dataReceiv) {
        //   // let body = { preSale: presaleDetails?.preSale, MyContribution: formatToken(dataContri, presaleDetails?.custom_fund_token_decimal), address: account.address,chain:chain?.id, receivedTokens: formatToken(dataReceiv, presaleDetails?.token_decimal) }
        //   let body = {
        //     preSale: presaleDetails?.preSale,
        //     MyContribution: String(dataContri),
        //     address: account.address,
        //     chain: chain?.id,
        //     receivedTokens: String(dataReceiv),
        //     hash: receipt.transactionHash,
        //   };
        //   /*
        //                 not calling from frontend to prevent security issue
        //             */
        //   // let response = await postInvestAction(body)
        //   // if (response) {
        //   setTimeout(() => {
        //     getInvestDetailsFunc();
        //   }, 2000);

        //   referchFundraise();
        //   // }
        // }
      } else {
        const { data: dataContri } = await refetchInvestorContribution();
        // // const { data: dataReceiv } = await refetchInvestorReceivedTokens()
        // if (dataContri) {
        //   // let body = { preSale: presaleDetails?.preSale, MyContribution: formatToken(dataContri, presaleDetails?.custom_fund_token_decimal), address: account.address,chain:chain?.id, receivedTokens: formatToken(0, presaleDetails?.token_decimal) }
        //   let body = {
        //     preSale: presaleDetails?.preSale,
        //     MyContribution: String(dataContri),
        //     address: account.address,
        //     chain: chain?.id,
        //     receivedTokens: String(0),
        //     hash: receipt.transactionHash,
        //   };
        //   // let response = await postInvestAction(body)
        //   // if (response) {
        //   setTimeout(() => {
        //     getInvestDetailsFunc();
        //   }, 2000);

        //   referchFundraise();
        //   // }
        // }
      }

      let body = {
        preSale: presaleDetails?.preSale,
        address: account.address,
        hash: receipt.transactionHash,
        coupon_code: coupon,
        discount_amount: AbleToDetect,
        actual_payable_amount: amountDollar
      };

      await delay(4000);
      let response = await postInvestAction(body);
      if (response) {
        getInvestDetailsFunc();
        referchFundraise();
        closeModal();
      }
      formik.setFieldValue('amount', '');
      formik.setFieldTouched({});
      formik.setErrors({});
      toast.success(SUCCESSMSGS.INVESTED_CONTRIBUTION_SUCCESS);
    } catch (err) {
      console.log(err, 'error');
    } finally {
      setIsDepositing(false);
    }
  };

  const {
    data,
    isError: isErrorWaitForTrans,
    isLoading: isLoadingWaitForTrans,
  } = useWaitForTransaction({
    hash: investDataEth?.hash,
    onSuccess: onSuccessWaitForTransaction,
  });

  const {
    data: DataNotEth,
    isError: isErrorWaitForTransNotEth,
    isLoading: isLoadingWaitForTransNotEth,
  } = useWaitForTransaction({
    hash: investDataNotEth?.hash,
    onSuccess: onSuccessWaitForTransaction,
  });

  // Check for The Not Eth
  const onErrorAllowance = (error) => {
    PostErrorLogAction({
      address: account?.address || 0,
      other_detail: { error },
    });
    console.log('onErrorAllowance', error);
  };

  const onSuccessAllowance = (data) => {
    // console.log("onSuccessAllowance data", data)
  };

  const {
    data: isAllowanceData,
    isError: isErrorAllowance,
    isLoading: isLoadingAllowance,
    refetch: refetchAllowance,
  } = useContractRead({
    address:
      presaleDetails?.buyToken != undefined
        ? presaleDetails?.buyToken
        : undefined,
    abi: SimpleToken.abi,
    functionName: 'allowance',
    args: [account.address, presaleDetails?.preSale],
    onSuccess: onSuccessAllowance,
    onError: onErrorAllowance,
  });

  const onSuccessApprove = (data) => {
    refetchAllowance();
  };

  const {
    data: approvedData,
    write: approveToken,
    isLoading: isLoadingApprove,
    isSuccess: isApprovedSuccess,
  } = useContractWrite({
    address:
      presaleDetails?.buyToken != undefined
        ? presaleDetails?.buyToken
        : undefined,
    abi: SimpleToken.abi,
    functionName: 'approve',
    args: [
      presaleDetails?.preSale,
      ethers.utils
        // .parseUnits(String(formik.values.amount || 0), dynamicDecimal || 0)
        .parseUnits(String(adjustedAmount || 0), dynamicDecimal || 0)
        ?.toString(),
    ],
    onError: onApproveError,
    onSuccess: onSuccessApprove,
  });

  const onSuccessWaitForTransactionApprove = (data) => {
    // toast.success(SUCCESSMSGS.APPROVED_SUCCESS)
    // refetchAllowance()
  };

  const onApproveReceipt = (receipt) => {
    toast.success(SUCCESSMSGS.APPROVED_SUCCESS);
    refetchAllowance();
  };

  // Waiting for tx to mine.
  const { isLoading: isLoadingWaitForTranasaction } = useWaitForTransaction({
    hash: approvedData?.hash,
    onSettled: onApproveReceipt,
    onSuccess: onSuccessWaitForTransactionApprove,
  });

  function isNumberKey(value) {
    value = value ? value : '';
    // alert(value)
    var validNumber = new RegExp(/^[0-9]*(\.[0-9]*)?$/);
    if (validNumber.test(value)) {
      return value;
    } else {
      return false;
    }
  }
  let btn_buy =
    presaleDetails.chain != chain?.id ||
      formik.errors.amount ||
      formik.values.amount == '' ||
      isInvestLoading ||
      isInvestNotEthLoading ||
      isLoadingWaitForTrans ||
      isLoadingWaitForTransNotEth
      ? null
      : 'btn_buy';
  let Approve =
    presaleDetails.chain != chain?.id ||
      formik.errors.amount ||
      formik.values.amount == '' ||
      isInvestLoading ||
      isInvestNotEthLoading ||
      isLoadingWaitForTrans ||
      isLoadingWaitForTransNotEth ||
      isLoadingApprove ||
      isLoadingWaitForTranasaction
      ? null
      : 'btn_buy';

  // NEW CODE FOR COUPAN



  // const handleSendOTP = async (value) => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("code", value);

  //     const response = await sendCouponOTPAction(formData);
  //     console.log("Response:>>>>>>>>>>>", response.data);
  //     if (response.data.status === 200) {
  //       setMessage(response?.data?.message || "OTP sent successfully");
  //       toast.success(response?.data?.message);
  //       setIsLoading(false);
  //       setIsOtpRecived(true)
  //     } else {
  //       setMessage(response?.data?.message || "Invalid Coupon");
  //       toast.error(response?.data?.message);
  //     }
  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error("Error:", err);
  //     setIsLoading(false);
  //   }
  // };

  const handleCoupon = (e) => {
    const value = e.target.value.trim(); // Corrected typo
    setCoupon(value); // Update coupon state
    if (value.length === 6) {
      setIsLoading(true);
    }

  };

  const calculatePersantageAmount = (amount, percentage) => {
    if (couponUserData) {
      const calculatedValue = (amount * percentage) / 100;
      if (calculatedValue > 0) {
        setAbleToDetect((amount * percentage) / 100);
      }
      setcouponAmountAbleToDetect(calculatedValue)
    }
  }

  useEffect(() => {
    calculatePersantageAmount(Number(formik.values.amount), Number(percentage))
  }, [formik.values.amount, percentage, couponUserData]);


  // const deductAmount = async () => {
  //   try {
  //     const formData = new FormData();
  //     // formData.append("code", coupon);
  //     // formData.append("otp", otp);
  //     // formData.append("amount", amountDollar);

  //     formData.append("code", 'BENITQ');
  //     formData.append("otp", 123456);
  //     formData.append("amount", 3.3);

  //     const response = await deductAmountAction(formData);
  //     if (response.data.status === 200) {
  //       toast.success(response?.data?.message);
  //       const id = response?.data?.id; // Store the ID locally
  //       setDeductAmountId(id)
  //       console.log(response?.data, "akjgdyasjfdksfdasdyuadkasudyadksaytd");
  //       setMessage("");
  //       setIsLoading(false);
  //       return id
  //     } else {
  //       toast.error(response?.data?.message);
  //     }
  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error("Error:", err);
  //     setIsLoading(false);
  //   }
  // };


  // const handleVerifyTxnOTPAction = async (id, hash) => {
  //   console.log(deductAmountID, "hash>>>>>>>", hash)
  //   try {
  //     const formData = new FormData();
  //     formData.append("id", id);
  //     formData.append("hash", hash);

  //     const response = await verifyTxnOTPAction(formData);
  //     if (response.data.status === 200) {
  //       toast.success(response?.data?.message);
  //       console.log(response?.data?.balance);
  //       setIsLoading(false);
  //     } else {
  //       toast.error(response?.data?.message);
  //     }
  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error("Error:", err);
  //     setIsLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   setamountDollar(convertHLPERToUSD(couponAmountAbleToDetect, '3.36978'))
  //   console.log(`${couponAmountAbleToDetect} HLPER is equivalent to $${amountDollar}`);
  // }, [couponAmountAbleToDetect, couponBalance])

  console.log("isInvestLoading Loading---------", isInvestLoading)
  console.log("isInvestNotEthLoading Loading---------", isInvestNotEthLoading)
  console.log("isLoadingWaitForTrans Loading---------", isLoadingWaitForTrans)
  console.log("isLoadingWaitForTransNotEth Loading---------", isLoadingWaitForTransNotEth)

  return (
    <>
      {!isContribute &&
        <p className='text-center text-sm-end mb-4 text-white fs-55 fw-normal'>
          Contribute
        </p>
      }
      <div className='d-flex gap-2 align-items-stretch'>
        <div className=''>
          <div className='contribute_amount_input'>
            <input
              type='number'
              onWheel={(e) => e.target.blur()}
              onKeyDown={blockInvalidChar}
              name='amount'
              placeholder='Amount'
              className={`btn-border-blue no-arrow ${formik.errors.amount && 'invalid'
                }`}
              // onChange={formik.handleChange}
              value={formik.values.amount}
              // onChange={(e) => {
              //     const inputValue = isNumberKey(e.target.value);
              //     // const numericValue = inputValue.replace(/[^0-9.]/g, ""); // Remove non-numeric characters except dot (.)
              //     const numericValue = inputValue; // Remove non-numeric characters except dot (.)
              //     if (numericValue !== false) {
              //         if (e.target.value.length < 21) {
              //             formik.handleChange({
              //                 target: {
              //                     name: "amount",
              //                     value: numericValue,
              //                 },
              //             });
              //         }
              //     }

              // }}
              onChange={(e) => {
                const inputValue = e.target.value;
                const decimalPart = inputValue.split('.')[1];
                let limitedNumericValue = inputValue;
                if (decimalPart && decimalPart.length > 18) {
                  limitedNumericValue =
                    inputValue.split('.')[0] + '.' + decimalPart.slice(0, 18);
                }
                formik.handleChange({
                  target: {
                    name: 'amount',
                    value: limitedNumericValue,
                  },
                });
              }}
              disabled={
                isInvestLoading ||
                isInvestNotEthLoading ||
                isLoadingWaitForTrans ||
                isLoadingWaitForTransNotEth ||
                isLoadingApprove ||
                isLoadingWaitForTranasaction
              }
            />
          </div>
          {formik.errors.amount && (
            <p className='error-msg m-0 mt-1' style={{ lineHeight: '20px' }}>
              {formik.errors.amount}
            </p>
          )}
        </div>
        <>
          {presaleDetails?.buyWithETH == 'false' ? (
            <>
              {isAllowanceData == undefined ||
                Number(
                  ethers.utils
                    .formatUnits(
                      String(isAllowanceData || 0),
                      Number(presaleDetails?.custom_fund_token_decimal || 0)
                    )
                    .toString()
                ) < Number(adjustedAmount) ? (
                <button
                  className={`${Approve} btn btn-primary btn-lg rounded-3 d-flex align-items-center justify-content-center`}
                  type='button'
                  style={{
                    height: '46.2px',
                  }}
                  disabled={
                    presaleDetails.chain != chain?.id ||
                    formik.errors.amount ||
                    formik.values.amount == '' ||
                    isInvestLoading ||
                    isInvestNotEthLoading ||
                    isLoadingWaitForTrans ||
                    isLoadingWaitForTransNotEth ||
                    isLoadingApprove ||
                    isLoadingWaitForTranasaction
                  }
                  onClick={approveToken}
                // onClick={() => investIntoPreSale()}
                >
                  {isLoadingApprove || isLoadingWaitForTranasaction
                    ? 'Approving..'
                    : 'Approve'}
                </button>
              ) : (
                <button
                  className={`${btn_buy} btn btn-primary btn-lg rounded-3 d-flex align-items-center justify-content-center`}
                  type='button'
                  style={{
                    height: '46.2px',
                  }}
                  disabled={
                    presaleDetails.chain != chain?.id ||
                    formik.errors.amount ||
                    formik.values.amount == '' ||
                    isInvestLoading ||
                    isInvestNotEthLoading ||
                    isLoadingWaitForTrans ||
                    isLoadingWaitForTransNotEth ||
                    isDepositing
                  }
                  onClick={(event) => {
                    event.preventDefault();
                    formik.handleSubmit();
                  }}
                // onClick={() => investIntoPreSale()}
                >
                  {isInvestLoading ||
                    isInvestNotEthLoading ||
                    isLoadingWaitForTrans ||
                    isLoadingWaitForTransNotEth ||
                    isDepositing
                    ? 'Depositing...'
                    : 'Buy'}
                </button>
              )}
            </>
          ) : (
            <button
              className={`${btn_buy} btn btn-primary btn-lg rounded-3 d-flex align-items-center justify-content-center`}
              type='button'
              style={{
                height: '46.2px',
              }}
              disabled={
                presaleDetails.chain != chain?.id ||
                formik.errors.amount ||
                formik.values.amount == '' ||
                isInvestLoading ||
                isInvestNotEthLoading ||
                isLoadingWaitForTrans ||
                isLoadingWaitForTransNotEth ||
                isDepositing
              }
              onClick={(event) => {
                event.preventDefault();
                formik.handleSubmit();
              }}
            // onClick={() => investIntoPreSale()}
            >
              {isInvestLoading ||
                isInvestNotEthLoading ||
                isLoadingWaitForTrans ||
                isLoadingWaitForTransNotEth
                ? 'Depositing...'
                : 'Buy'}
            </button>
          )}
        </>
      </div>
      {presaleDetails.buyToken === config.HLPR_ADDRESS && (
        // <div className="text-danger mb-2"> Note: Your investor limit is currently set to 0, preventing any purchases at this time.</div>
        <div className='text-info mb-4'>
          {' '}
          Note: Buy Amount should be less than or equal to buy limit.
        </div>
      )}
      {isUSDT && formik.values.amount && !formik.errors.amount &&
        <h6 className='px-0 py-2 fs-6 fw-normal text-muted'
          onClick={() => {
            // Clear data when modal opens (optional)
            setCoupon("");
            setCouponUserData(null);
            setcouponAmountAbleToDetect();
          }}
          style={{ cursor: "pointer" }}>
          Do you have a coupon ? <span type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" className='text-info apply_coupon'> Apply Coupon </span>
        </h6>
      }
      <div class="modal fade"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        onHidden={() => {
          setCoupon("");
          setCouponUserData(null)
          setcouponAmountAbleToDetect()
          setamountDollar('')
          setAbleToDetect('')
        }}
      >
        <div class="modal-dialog "
          style={{
            maxWidth: '550px',
            marginTop: "150px"
          }}>
          <div class="modal-content">
            <div class="modal-header" style={{ background: '#2460ed' }}>
              <h5 class="modal-title" id="exampleModalLabel">Apply Coupon</h5>
              <button type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setCoupon("");
                  setCouponUserData(null)
                  setcouponAmountAbleToDetect()
                  setamountDollar('')
                  setAbleToDetect('')
                }}
              ></button>
            </div>
            <div class="modal-body approve_token_form">

              <form>
                <div class="mb-3">
                  <label for="recipient-name" class="form-label">Enter Coupon:</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder='Enter Your Coupon'
                    value={coupon}
                    disabled={isOtpRecived}
                    onChange={handleCoupon}

                  />
                  {/* {message && <p>{message}</p>} */}
                  {!isLoadingOtp && message &&
                    <p className='mt-2'>{message}</p>
                  }
                  {isLoadingOtp &&
                    <SyncLoader color="#2360ed" className="mt-2" />
                  }
                </div>
                {/* {!couponBalance && <>
                  {!isLoadingOtp && isOtpRecived &&
                    <>
                      <div class="mb-3">
                        <label for="message-text" class="col-form-label">OTP:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder='Enter Your otp'
                          value={otp}
                          onChange={verifyOtp}
                        />
                      </div>
                      <div className='d-flex justify-content-end'>
                        <button disabled={otp.length < 5} onClick={verifyCouponOTP} type="button" class="btn btn-primary min-w-btn align-items-center justify-content-center d-flex mt-1 mb-1">Verify Otp</button>
                      </div>
                    </>
                  }
                </>} */}
              </form>
              {couponUserData?.[0] > 0 &&
                <>
                  {/* <h5 class="modal-title" id="exampleModalLabel"> Coupon Value: ${couponUserData?.[0] ? ethers.utils.formatUnits(String(couponUserData[0]), 18) : null} and Remaining Balance: ${couponUserData?.[1] ? ethers.utils.formatUnits(String(couponUserData[1]), 18) : null}</h5>
                  <h5 class="modal-title" id="exampleModalLabel"> Amout Detect from Coupon $ {couponAmountAbleToDetect}</h5> */}

                  <div className="text-muted">
                    {couponUserData?.[1] == "0.0" || couponUserData?.[1] == "0" ? (
                      // Case: When couponUserData[1] is zero
                      <>
                        <span className="text-danger fw-semibold">
                          Your coupon balance is $0.00.
                        </span>
                        <p className='mb-0 mt-1'>
                          <span className="fw-normal">
                            We're sorry, but your coupon has no remaining balance to redeem
                          </span>
                        </p>

                      </>
                    ) : (
                      // Case: When couponUserData[1] is greater than zero
                      <>

                        Your coupon balance is{" "}
                        <span className="text-primary fw-semibold">
                          ${ethers.utils.formatUnits(String(couponUserData[1]), 18)}
                        </span>.
                        <br />
                        <p className='mb-0 mt-1'>
                          {balanceofCoupam < couponAmountAbleToDetect ? (
                            <>
                              <span className="text-success fw-semibold">
                                ${balanceofCoupam} USD
                              </span>{" "}
                              will be deducted from your coupon, as the balance is less than the required amount.

                              <br />
                            </>
                          ) : (
                            <>
                              <span className="text-success fw-semibold">
                                ${couponAmountAbleToDetect} USD
                              </span>{" "}
                              (which is{" "}
                              <span className="text-success fw-semibold">{percentage}%</span>{" "}
                              of your entered amount) will be deducted from your coupon.
                              <br />
                            </>
                          )}
                          Ready to redeem it? Click <span className="fw-bold">‘Approve‘</span> to continue.
                        </p>
                      </>
                    )}
                  </div>
                  {couponUserData?.[1] == "0.0" || couponUserData?.[1] == "0" ? null :
                    <div className='d-flex justify-content-end mt-2'>
                      {/* <button type="button" onClick={approveToken} class="btn btn-primary min-w-btn align-items-center justify-content-center d-flex mt-1 mb-1">Proceed</button> */}

                      <>
                        {presaleDetails?.buyWithETH == 'false' ? (
                          <>
                            {isAllowanceData == undefined ||
                              Number(
                                ethers.utils
                                  .formatUnits(
                                    String(isAllowanceData || 0),
                                    Number(presaleDetails?.custom_fund_token_decimal || 0)
                                  )
                                  ?.toString()
                              ) < Number(adjustedAmount) ? (
                              <button
                                className={`${Approve} btn btn-primary btn-lg rounded-3 d-flex align-items-center justify-content-center`}
                                type='button'
                                style={{
                                  height: '46.2px',
                                }}
                                disabled={
                                  presaleDetails.chain != chain?.id ||
                                  formik.errors.amount ||
                                  formik.values.amount == '' ||
                                  isInvestLoading ||
                                  isInvestNotEthLoading ||
                                  isLoadingWaitForTrans ||
                                  isLoadingWaitForTransNotEth ||
                                  isLoadingApprove ||
                                  isLoadingWaitForTranasaction
                                }
                                onClick={approveToken}
                              // onClick={() => investIntoPreSale()}
                              >
                                {isLoadingApprove || isLoadingWaitForTranasaction
                                  ? 'Approving..'
                                  : 'Approve'}
                              </button>
                            ) : (
                              <button
                                className={`${btn_buy} btn btn-primary btn-lg rounded-3 d-flex align-items-center justify-content-center`}
                                type='button'
                                style={{
                                  height: '46.2px',
                                }}
                                disabled={
                                  presaleDetails.chain != chain?.id ||
                                  formik.errors.amount ||
                                  formik.values.amount == '' ||
                                  isInvestLoading ||
                                  isInvestNotEthLoading ||
                                  isLoadingWaitForTrans ||
                                  isLoadingWaitForTransNotEth ||
                                  isDepositing
                                }
                                onClick={(event) => {
                                  event.preventDefault();
                                  formik.handleSubmit();
                                }}
                              // onClick={() => investIntoPreSale()}
                              >
                                {isInvestLoading ||
                                  isInvestNotEthLoading ||
                                  isLoadingWaitForTrans ||
                                  isLoadingWaitForTransNotEth ||
                                  isDepositing
                                  ? 'Depositing...'
                                  : 'Buy'}
                              </button>
                            )}
                          </>
                        ) : (
                          <button
                            className={`${btn_buy} btn btn-primary btn-lg rounded-3 d-flex align-items-center justify-content-center`}
                            type='button'
                            style={{
                              height: '46.2px',
                            }}
                            disabled={
                              presaleDetails.chain != chain?.id ||
                              formik.errors.amount ||
                              formik.values.amount == '' ||
                              isInvestLoading ||
                              isInvestNotEthLoading ||
                              isLoadingWaitForTrans ||
                              isLoadingWaitForTransNotEth ||
                              isDepositing
                            }
                            onClick={(event) => {
                              event.preventDefault();
                              formik.handleSubmit();
                            }}
                          // onClick={() => investIntoPreSale()}
                          >
                            {isInvestLoading ||
                              isInvestNotEthLoading ||
                              isLoadingWaitForTrans ||
                              isLoadingWaitForTransNotEth
                              ? 'Depositing...'
                              : 'Buy'}
                          </button>
                        )}
                      </>
                    </div>
                  }
                  {/* {couponUserData?.[1] == "0.0" || couponUserData?.[1] == "0" &&
                    <div className='d-flex align-items-center justify-content-center mt-3'>
                      <button
                        className={`btn btn-primary btn-lg rounded-3 d-flex align-items-center justify-content-center`}
                        type='button'
                        style={{
                          height: '46.2px',
                        }}
                        onClick={closeModal}
                      // onClick={() => investIntoPreSale()}
                      >
                        OK
                      </button>
                    </div>
                  } */}
                </>
              }

            </div>

          </div>
        </div>
      </div>

      {balance?.formatted == '0' && presaleDetails?.chain == chain?.id && (
        <div className='custom-alert mt-3'>
          <div className='custom-alert-icon'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
              aria-hidden='true'
              role='img'
              width='1em'
              height='1em'
              preserveAspectRatio='xMidYMid meet'
              viewBox='0 0 24 24'
            >
              <g id='iconifyReact297'>
                <g id='iconifyReact298'>
                  <path
                    id='iconifyReact299'
                    fill='rgb(255, 193, 7)'
                    d='M22.56 16.3L14.89 3.58a3.43 3.43 0 0 0-5.78 0L1.44 16.3a3 3 0 0 0-.05 3A3.37 3.37 0 0 0 4.33 21h15.34a3.37 3.37 0 0 0 2.94-1.66a3 3 0 0 0-.05-3.04ZM12 17a1 1 0 1 1 1-1a1 1 0 0 1-1 1Zm1-4a1 1 0 0 1-2 0V9a1 1 0 0 1 2 0Z'
                  />
                </g>
              </g>
            </svg>
          </div>
          <div className='custom-alert-message text-center'>
            You have no funds!
          </div>
        </div>
      )}

      {config.HLPR_ADDRESS === presaleDetails?.buyToken && (
        <ul className='presale_address_ui'>
          <li className='d-flex justify-content-between'>
            <p>Buy Limit</p>
            {/* <p>{ethers.utils.formatUnits(investorLimit, 18)} HLPR</p> */}
            <p>{ethers.utils.formatUnits(investorLimit.at(0) ?? BigInt(0) - investorLimit.at(1) ?? BigInt(0), 18)} HLPR</p>
          </li>
          <li style={{ display: 'none' }}></li>
        </ul>
      )}
    </>
  );
}
